import { getFirebaseBackend } from '../../helpers/firebase/authUtils';
import api from '@/helpers/api-rest/api.js';

export const state = {
    currentUser: localStorage.getItem('user'),
}

export const mutations = {
    SET_CURRENT_USER(state, newValue) {
        state.currentUser = newValue ? JSON.stringify(newValue) : null
        saveState('user', newValue)
    },
}

export const getters = {
    // Whether the user is currently logged in.
    loggedIn(state) {
        return !!state.currentUser
    },

    role(state){
        const currentUser = state.currentUser ? JSON.parse(state.currentUser) : null;
        if (!currentUser) {
            return null;
        }
        
        return currentUser.roles[0];
    },

    nameUser(state){
        const currentUser = state.currentUser ? JSON.parse(state.currentUser) : null;
        if (!currentUser) {
            return null;
        }
        
        return currentUser.name;
    }
}

export const actions = {
    // This is automatically run in `src/state/store.js` when the app
    // starts, along with any other actions named `init` in other modules.
    // eslint-disable-next-line no-unused-vars
    init({ state, dispatch }) {
        dispatch('validate')
    },

    // Logs in the current user.
    logIn({ commit, dispatch, getters }, { email, password } = {}) {
        if (getters.loggedIn) return dispatch('validate')

        return getFirebaseBackend().loginUser(email, password).then((response) => {
            const user = response
            commit('SET_CURRENT_USER', user)
            return user
        });
    },

    setUser({ commit }, user) {
        commit('SET_CURRENT_USER', user)
    },

    logOut({ commit }) {
        commit('SET_CURRENT_USER', null)
    },

    // register the user
    register({ commit, dispatch, getters }, { email, password } = {}) {
        if (getters.loggedIn) return dispatch('validate')

        return getFirebaseBackend().registerUser(email, password).then((response) => {
            const user = response
            commit('SET_CURRENT_USER', user)
            return user
        });
    },

    async forgotPassword({ getters }, { email } = {}) {
        console.log( getters);

        await api.save({
            url: '/api/v1/auth/forgot-password',
            data:{
                email:email
            },
            config: {
                withLoading: true
            }
        });
    },

    async resetPassword({ getters }, { token, email, password, re_password } = {}) {
        console.log( getters);
        await api.post({
            url: '/api/v1/auth/reset-password',
            data:{
                token:token,
                email:email,
                password:password,
                re_password:re_password,
            }
        });
    },

    async validateResetToken({ getters }, { email, token } = {}) {
        console.log( getters);
        await api.post({
            url: '/api/v1/auth/validate-reset-token',
            data:{
                token:token,
                email:email
            }
        });
    },
}

// ===
// Private helpers
// ===

function saveState(key, state) {
    if (state) {
        window.localStorage.setItem(key, JSON.stringify(state))
    }else{
        window.localStorage.removeItem(key);
        window.localStorage.removeItem('authToken');
    }
}
